import { invalidateNotificationsQueryCache } from "@circle-react-shared/Notifications/useHeaderNotificationsApi";
import { useQueryClient } from "react-query";

import { t } from "@/i18n-js/instance";
import { useToast } from "@/react/components/SettingsApp/CompassCompat/Toast";
import { useFlagConnection } from "@/react/hooks/connections/useFlagConnection";

import type { MemberInfo } from "./types";
import { invalidateAllMemberQueries } from "./util";

export const useFlagConnectionForUser = ({
  member,
}: {
  member?: MemberInfo;
}) => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const { mutate: flagConnection, isPending: isFlagging } = useFlagConnection({
    onSuccess: async () => {
      await invalidateAllMemberQueries(queryClient, member?.public_uid ?? "");
      invalidateNotificationsQueryCache({ queryClient });
      toast.success(
        t("profile_drawer.connect_banner.messages.connection_flagged", {
          name: member?.name,
        }),
      );
    },
    onError: () => {
      toast.error(
        t("profile_drawer.connect_banner.messages.connection_flag_error"),
      );
    },
  });

  return {
    flagConnectionForUser: flagConnection,
    isFlagging,
  };
};
